import { faArrowRight } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Divider, Grid, IconButton, Stack, Typography } from '@vapor/material'
import { Trans, useTranslation } from 'react-i18next'
import useFormatDate from 'src/app/hooks/current-locale/use-format-date'

type CoReferenceDocumentHeaderProps = {
  numberExtended: string
  documentDate: Date
  openReferenceDocument?: () => void
}

export default function CoReferenceDocumentHeader({ numberExtended, documentDate, openReferenceDocument }: CoReferenceDocumentHeaderProps) {
  const formatDate = useFormatDate()
  const { t } = useTranslation()

  return (
    <Grid item xs={12}>
      <Stack direction="column" spacing={1} mb={1}>
        <Typography variant="body">
          <b>{t('pms.common.checkout_document.amounts.reference_document.title')}</b>
        </Typography>
        <Stack direction="row" spacing={1}>
          <Typography variant="body">
            <Trans
              i18nKey="pms.common.checkout_document.amounts.reference_document.value"
              values={{
                documentNumber: numberExtended,
                documentDate: formatDate(documentDate),
              }}
            />
          </Typography>
          {openReferenceDocument && <FontAwesomeIcon color="var(--DarkImperialBlue)" icon={faArrowRight} width="15px" height="15px" onClick={openReferenceDocument} style={{ cursor: 'pointer' }} />}
        </Stack>
      </Stack>
      <Divider light />
    </Grid>
  )
}
